import {CarrierApprovalInformationEntity} from '../../services/carrier/carrier';

export class AgencyMaster {
  agnncyMasterId: number;
  agencyCode: string;
  bureauCode: string;
  agencyBureauName: string;
  updateProgram = '';
  updateId: number;
  updateDate: any = 0;
  agencyMasterId?: any;
}

export class Organization {
  organizationId: number;
  firstName: string;
  lastName: string;
  middleInitial: string;
  email: string;
  title: string;
  addressLine1: string;
  addressLine2: string;
  addressModifiedDate: any = 0;
  city: string;
  stateId: string;
  zip: string;
  zipSuffix: string;
  countryId: string;
  phone: string;
  phoneExtension: string;
  stopMail: boolean;
  bookingEmail: string;
  organizationStatus: string;
  permission: string;
  createdProgram: string;
  createdDate: any;
  createdId: number;
  updateProgram: string;
  updateId: number;
  updateDate: any = 0;
  stateName: string;
  countryName: string;
  carrierEntity: Carrier;
}

export class StateCountry {
  businessType: string;
  stateCountryId: number;
  stateCountryType: string;
  stateCountryCode: string;
  stateCountryCode2Digit: string;
  stateCountryName: string;
  schedule: string;
  deptOfState: boolean;
  serviceAreaId: number;
  parentCountryId: number;
  contiguousUS: number;
  stateTariffUse: number;
  updateProgram: string;
  updateId: number;
  updateDate: any;
  frtRatesZoneId?: number;
}

export class Scope {
  scopeId: number;
  carrierId: number;
  originId: number;
  destinationId: number;
  scopeType: string;
  updateProgram: string;
  updateId: number;
  updateDate: string;
  stateCountryOrigDetails: StateCountry;
  stateCountryDestDetails: StateCountry;
}

export class Carrier {
  carrierId: number;
  scac: string;
  businessType: string;
  scacName: string;
  carrierType: string;
  dunsNumber: string;
  dunsPlus: string;
  uniqueEntityIdentifier: string;
  carrierApprovalInformationEntity: CarrierApprovalInformationEntity[];
  smartWayId: number;
  smartWayScore: number;
  rateFileReceipt: number;
  rateFileReceiptDate: Date;
  organizationId: number;
  carrierStatus: string;
  deletedId: number;
  deletedDate: Date;
  shipmentRptContFirstName: string;
  shipmentRptContLastName: string;
  shipmentRptContMiddleInitial: string;
  shipmentRptContEmail: string;
  shipmentRptContPhone: string;
  shipmentRptContPhoneExtension: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  organizationEntity: Organization;

}

export class UspsZipCityState {
  uspsZipId: number;
  zipCode: string;
  zipClassificationCode: string;
  cityName: string;
  cityAbbrev: string;
  stateAbbrev: string;
  countyNo: string;
  countyName: string;
  updateProgram: string;
  updateId: number;
  updateDate: any;
  stateId: number;
}

export class RatesSroMaster {
  sroMasterId: number;
  sroId: string;
  agencyMasterId: number;
  agencyId: number;
  businessType: string;
  sroType: string;
  openForFiling: number;
  effectiveDate: Date;
  expiryDate: Date;
  deletedFlag: number;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  sroNotes: string;
  ratesSroOriginDestinationEntity: RatesSroOriginDestination[];
  rateTypesSroEntity: RateTypesSro[];
}

export class RatesSroOriginDestination {
  orgnDestId: number;
  sroMasterId: number;
  originId: number;
  originCity: string;
  originZip: string;
  originState: string;
  destinationId: number;
  destinationCity: string;
  destinationZip: string;
  destinationState: string;
  countryName?: string;
  updateProgram: string;
  updateId: number;
  updateDate: string;
  stateCountryOrigDetails: StateCountry;
  stateCountryDestDetails: StateCountry;
}

export class HhgRates {
  procureId: number;
  transportType: string;
  rateTypeId: number;
  carrierId: number;
  tenderId: string;
  sroMasterId: number;
  controlId: number;
  originId: number;
  destinationId: number;
  destinationType: string;
  linehaul: number;
  classVehicle1: string;
  classVehicle2: string;
  classVehicle3: string;
  storageInTransit: number;
  accessorials: number;
  unaccompaniedAirBag: number;
  bookingEmail: string;
  bookingPhone: string;
  updateFlag: string;
  updateProgram: string;
  updateId: string;
  updateDate: Date;
}

export class RateTypes {
  rateTypeId: number;
  description: string;
  businessType: string;
  legacyRateType: number;
  transportationType: string;
  sroType: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class RateTypesSro {
  rateTypeSroId: number;
  rateTypeId: number;
  sroMasterId: number;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}


export class RatesTspScope {
  scopeId: number;
  carrierId: number;
  originId: number;
  destinationId: number;
  originServiceAreaId?: number;
  scopeType: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  stateCountryOrigDetails: StateCountry;
  stateCountryDestDetails: StateCountry;

  constructor(carrierId: number, originId: number, destinationId: number, scopeType: string) {
    this.carrierId = carrierId;
    this.originId = originId;
    this.destinationId = destinationId;
    this.scopeType = scopeType;
  }
}

export class RatesProcureStatusChange {
  procureStatusChangeId: number;
  ratesProcureStatusId: number;
  userId: number;
  statusChangeDate: Date;
  hhgProcureId: number;
  frtProcureId: number;
  status: string;
  globalUpdateDescription: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class ForgotPassword {
  email: string;
  lastName: string;
}

export class ResetPassword {
  email: string;
  password: string;
  otpCode: number;
  secretQuestion: string;
  secretAnswer: string;
}

export class RatesHhgProcure {
  procureId: number;
  rateTypeId: number;
  carrierId: number;
  tenderId: string;
  sroMasterId: number;
  controlId: number;
  originId: number;
  destinationId: number;
  destinationType: string;
  linehaul: number;
  classVehicle1: string;
  classVehicle2: string;
  classVehicle3: string;
  storageInTransit: number;
  accessorials: number;
  unaccompaniedAirBag: number;
  bookingEmail: string;
  bookingPhone: string;
  updateFlag: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class RatesHhgProcureUpdate {
  carrId:number;
  transportType:string;
  ratesHhgProcureEntityList: RatesHhgProcure[];
}

export class FrtAcessorialsMaster {
  frtAccessorialsId: number;
  unitsId: number;
  sroMasterId: number;
  accessorialCode: string;
  accessorialDescription: string;
  rangeFrom: number;
  rangeTo: number;
  minCharge: number;
  maxCharge: number;
  usage: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class RatesFrtProcure {
  procureId: number;
  rateTypeId: number;
  carrierId: number;
  sroMasterId: number;
  controlId: number;
  originId: number;
  destinationId: number;
  tenderId: string;
  ltlSurchargePct: number;
  ltlMinimumChargePct: number;
  tlRateAmount: number;
  tlMinimumCharge: number;
  updateFlag: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class RatesFrtProcureEdit {
  procureId: number;
  rateTypeId: number;
  carrierId: number;
  sroMasterId: number;
  controlId: number;
  originId: number;
  destinationId: number;
  tenderId: string;
  ltlSurchargePct: number;
  ltlMinimumChargePct: number;
  tlRateAmount: number;
  tlMinimumCharge: number;
  updateFlag: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  originName: string;
  destinationName: string;
  sroId: string;
  ltlMax: number;
  ltlMin: number;
  tlMax: number;
  tlMin: number;
}

export class FrtServicesMaster {
  frtServicesMasterId: number;
  controlId: number;
  sroMasterId: number;
  serviceLevel: string;
  ltlMaximumChargePct: number;
  ltlMinimumChargePct: number;
  tlMinimumCharge: number;
  tlMaximumCharge: number;
  updateProgram: string;
  updateId: number;
  updateDate: Date;

}

export class FrtRateGlobalAcessorialUpdateRequest {
  frtAcessorialMasterId: number;
  accessorialChangeType: string;
  minCharge: number;
  rateAmount: number;
}

export class FrtRateGlobalUpdateRequest {
  sroMasterId: number;
  carrierId: number;
  originId: number;
  rateTypeId: number;
  tenderId: string;
  ltlMinCharge: number;
  ltlMinChargeChangeType: string;
  ltlSurchargePct: number;
  ltlSurchargePctChangeType: string;
  tlMinCharge: number;
  tlRateAmount: number;
  tlMinChargeChangeType: string;
  tlRateAmountChangeType: string;
  Acessorials: FrtRateGlobalAcessorialUpdateRequest[];
}

export class RatesFrtAccessorialsProcure {
  accessorialProcureId: number;
  frtAccessorialMasterId: number;
  carrierId: number;
  sroMasterId: number;
  accessorialAmount: number;
  minimumAmount: number;
  updateFlag: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  frtAccessorialsMasterEntity: FrtAcessorialsMaster;
}

// added organizationId to the request
export class HHGRateQueryRequest {
  queryId: number;
  queryDatetime: string;
  userId: number;
  organizationId: number;
  queryType = 'HHG';
  rateType: string;
  containerizedShipments: boolean;
  sroMasterId: number;
  originCountryId: number;
  originZipId: number;
  destinationCountryId: number;
  destinationZipId: number;
  pickupDate: string;
  estimatedWeight: number;
  miles: number;
  estimatedCuFt: number;
  uabWeight: number;
  vehicleClass: string;
  sitLocation: string;
  sitBreakDown: boolean;
  sitNoDays: number;
  employeeFirstName: string;
  employeeLastName: string;
  employeeMiddleName: string;
  savedFlag: boolean;
  orgId: number;
  screenName: string;
  updateProgram = 'Rates HHG Query';
  updateId: number;
  updateDate: string;
}

export class HHGRateQueryResult {
  rateType: string;
  scac: string;
  zeffFlag: boolean;
  companyName: string;
  telephone: string;
  tender: string;
  csi: number;
  vi: number;
  surfacePercentage: number;
  surfaceCharge: number;
  uabPercentage: number;
  uabCharge: number;
  vehicleCharge: number;
  totalCharge: number;
  sitRatePercentage: number;
  thirtyDayCharge: number;
  sixtyDayCharge: number;
  ninetyDayCharge: number;
  queryId: number;
  carrierId?: any;
  fuelSurchargeCost?: any;
  linehaulCostFinal?: any;
  baseChargeFinal?: any;
  exsPackagingCharge?: any;
  exsMonthlyStorageCharge?: any;
  exsWarehouseCharge?: any;
  exsTotal1MonthCharge?: any;
  exsTotal6MonthCharge?: any;
  exsTotal12MonthCharge?: any;
  exsDeliveryWithin50Miles?: any;
  exsDeliveryHandlingOut?: any;
  exsDeliveryOver50Miles?: any;
  effectiveDate?: any;
  expiryDate?: any;
}

export class PageRequest<T> {
  pageSize: number;
  pageNumber: number;
  entityRequest: T;
  filterCollection: PageFilter[];
  sortCollection: PageSort[];

  constructor(
    pageSize: number,
    pageNumber: number,
    filterCollection: PageFilter[],
    sortCollection: PageSort[],
    entity: T = null
  ) {
    this.pageSize = pageSize;
    this.pageNumber = pageNumber;
    this.filterCollection = filterCollection;
    this.sortCollection = sortCollection;
    this.entityRequest = entity;
  }
}

export class PageResponse<T> {
  totalElements: number;
  content: T[];
}

export class PageFilter {
  propertyName: string;
  filterValue: any;
  filterType: string;
  filterToValue: any;

  constructor(
    PropertyName: string,
    filterValue: any,
    filterType: string,
    filterToValue: any
  ) {
    this.propertyName = PropertyName;
    this.filterValue = filterValue;
    this.filterType = filterType;
    this.filterToValue = filterToValue;
  }
}

export class PageSort {
  propertyName: string;
  sortType: string;

  constructor(propertyName: string, sortType: string) {
    this.propertyName = propertyName;
    this.sortType = sortType;
  }
}

export class County {
  countyId: number;
  iccId: number;
  serviceAreaId: number;
  countyName: string;
  city: string;
  state: string;
  stateCode: string;
  countyCode: string;
  updateProgram = '';
  updateId: number;
  updateDate: any = 0;
}

export abstract class DelinquencyReport {
  scac: string;
  // 2019-3
  last1stQuarterCompleted: string;
  // 2019-2
  last2ndQuarterCompleted: string;
  // 2019-1
  last3rdQuarterCompleted: string;
  // 2018-4
  last4thQuarterCompleted: string;
}

export class HHGDelinquencyReport extends DelinquencyReport {
  last1stQuarterGIStatus: string;
  last2ndQuarterGIStatus: string;
  last3rdQuarterGIStatus: string;
  last4thQuarterGIStatus: string;
  last1stQuarterIMStatus: string;
  last2ndQuarterIMStatus: string;
  last3rdQuarterIMStatus: string;
  last4thQuarterIMStatus: string;
  last1stQuarterGDStatus: string;
  last2ndQuarterGDStatus: string;
  last3rdQuarterGDStatus: string;
  last4thQuarterGDStatus: string;
  last1stQuarterDMStatus: string;
  last2ndQuarterDMStatus: string;
  last3rdQuarterDMStatus: string;
  last4thQuarterDMStatus: string;
}

export class SITDelinquencyReport extends DelinquencyReport {
  last1stQuarterGIStatus: string;
  last2ndQuarterGIStatus: string;
  last3rdQuarterGIStatus: string;
  last4thQuarterGIStatus: string;
  last1stQuarterIMStatus: string;
  last2ndQuarterIMStatus: string;
  last3rdQuarterIMStatus: string;
  last4thQuarterIMStatus: string;
  last1stQuarterGDStatus: string;
  last2ndQuarterGDStatus: string;
  last3rdQuarterGDStatus: string;
  last4thQuarterGDStatus: string;
  last1stQuarterDMStatus: string;
  last2ndQuarterDMStatus: string;
  last3rdQuarterDMStatus: string;
  last4thQuarterDMStatus: string;
}

export class FRTDelinquencyReport extends DelinquencyReport {
  last1stQuarterStatus: string;
  last2ndQuarterStatus: string;
  last3rdQuarterStatus: string;
  last4thQuarterStatus: string;
}

export class IFFShipmentSummaryRequest {
  // HHG-General
  // HHG-SIT
  // FRT-General
  constructor(public businessType: string, public moveType: string) {
  }
}

export class IFFShipmentSummaryResponse {
  iffMasterId: number;
  scac: string;
  scacName: string;
  transportationType: string;
  status: string;
  moveType: string;
  receivedDate: any;
  reportingYear: number;
  reportingQuarter: number;
  numberOfShipments: number;
  grossAmount: number;
  netAmount: number;
  passThruAmount: number;
  totalIFF: number;
}

export class XTOSShipmentSummaryResponse {
  xtosMasterId: number;
  scac: string;
  scacName: string;
  storageType: string;
  status: string;
  moveType: string;
  receivedDate: any;
  reportingYear: number;
  reportingQuarter: number;
  numberOfShipments: number;
  netAmount: number;
  passThruAmount: number;
  totalIFF: number;
}

export class HHGIffShipmentDetailResponse {
  iffDetailsId: number;
  scac: string;
  scacName: string;
  iffMasterId: number;
  faicCode: string;
  agencyBureauName: string;
  proBillNumber: string;
  bolNumber: string;
  gblcbl: string;
  moveType: string;
  pickupDate: Date;
  deliveryDate: Date;
  originStateCode: string;
  destinationStateCode: string;
  employeeLastName: string;
  weight: number;
  miles: number;
  discount: number;
  grossAmount: number;
  netAmount: number;
  passThruAmount: number;
  totalIFF: number;
}

export class FRTIffShipmentDetailResponse {
  frtIFFDetailsId: number;
  iffMasterId: number;
  scac: string;
  scacName: string;
  agencyBureauName: number;
  proBillNumber: string;
  bolNumber: string;
  invoiceNumber: string;
  pickupDate: Date;
  datePaidByAgency: Date;
  shippingSystem: string;
  lineHaulCost: number;
  totalAccessorialCost: number;
  fuelSurChargeReceived: number;
  fuelSurChargeCompleted: number;
  amountSubjectToIFFReceived: number;
  amountSubjectToIFFCompleted: number;
  iffAmountDueReceived: number;
  iffAmountDueCompleted: number;
  paymentSystem: string;
  typeOfPayment: string;
  paymentDate: Date;
  paymentRefNumber: number;
  validationStatus: string;
  failureReason: string;
}

export class FrtShipmentPackagesEntity {
  frtShipmentPackagesId: number;
  packageTypeId: number;
  frtShipmentDetailsId: number;
  lineNo: number;
  totalPieces: number;
  noOfLoosePieces: number;
  noOfPallets: number;
  packageWeight: number;
  cubicFeet: number;
  commodityDesc: string;
  additionalComments: string;
  appropriationChargeCode: string;
  otherAppropriationChargeCode: string;
  hazmatIndicator: number;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  frtPackageTypesEntity: FrtPackageTypesEntity;
  hazmathIndOnScreen: string;
  truckNum: number;
}

export class FrtPackageTypesEntity {
  packageTypeId: number;
  packageCode: string;
  packageDescription: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class CarrierRfsps {
  rfspId: number;
  carrierIdRfsp: number;
  carrierIdTsp: number;
  rfspScac: String;
  tspScac: String;
  shipmentType: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class FrtPackagesItemsEntity {
  frtPackageItemsId: number;
  frtShipmentDetailsId: number;
  frtShipmentPackagesId: number;
  frtItemsMasterId: number;
  itemsQuantity: number;
  itemsWeight: number;
  otherDescription: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  // frtShipmentPackagesEntity: FrtShipmentPackagesEntity;
  frtItemsMasterEntity: FrtItemsMasterEntity;
}

export class FrtItemsMasterEntity {
  frtItemsMasterId: number;
  agencyMasterId: number;
  itemNumber: string;
  description: string;
  status: string;
  commodity: string;
  freightClass: string;
  updateId: number;
  updateDate: Date;
}

export abstract class Address {
  recordType: string;
  firstName: string;
  lastName: string;
  middleInitial: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateId: number;
  zipCode: string;
  countryId: number;
  phone: string;
  phoneExt: string;
  alternatePhone: string;
  otherContactInfo: string;
  emailAddress: string;
  updateProgram: string;
  updateId: number;
  updateDate: any;
  stateEntity: StateCountry;
  countryEntity: StateCountry;
  defaultAddress?: number;
}

export class NameAndAddress extends Address {
  nameAddressId: number;
  shipmentsId: number;
  frtOtoRequestId?: number;
  version: string;
  issuingOfficerTitle: string;
  issuingOfficeName: string;

  constructor(recordType?: string) {
    super();
    this.recordType = recordType;
  }
}

export class ShipmentPrefAddress extends Address {
  shipmentPrefAddressesId: number;
  userId: number;
  orgId?: number;
}

export class IssuingOfficeDetails {
  issuingOfficeName: string;
  officerFirstName: string;
  officerLastName: string;
  officerMiddleInitial: string;
  officerTitle: string;
  phoneNumber: string;
  phoneExtension: string;
}

export class HhgBillOfLadingInfo {
  shipmentsInfoId: number;
  bookShipmentId: number;
  shipmentType: string;
  billOfLadingNbr: string;
  bolIssuedDate: string;
  billOfLadingStatus: string;
  employeeFirstName: string;
  employeeLastName: string;
  employeeMiddleInitial: string;
  tspName: string;
  scac: string;
  dunsNumber: string;
  assignedAgentFirstName: string;
  assignedAgentLastName: string;
  email: string;
  phone: string;
  phoneExt: string;
  organizationId: string;
  moveDate: string;
  requestedPackDate: string;
  requiredDeliveryDate: string;
  specialRate: string;
  weight: number;
  vehicleType: string;
  additionalRemarks: string;
}

export class HhgBillOfLadingDetails {
  hhgBolDetailsId: number;
  shipmentsInfoId: number;
  bolNumber: string;
  bolStatus: string;
  transitTimeExpired: boolean;
  agencyShipmentIdNo: string;
  creationDate: string;
  tspProBillNo: string;
  travelOrderNumber: string;
  travelOrderDate: string;
  agencyLocationCode: string;
  appropriationChargeCode: string;
  otherAppropriationChargeCode: string;
  pbpeAppropriationChargeCode: string;
  povAppropriationChargeCode: string;
  otherPovAppropriationChargeCode: string;
  uabAppropriationChargeCode: string;
  otherUabAppropriationChargeCode: string;
  hhgBolPackagesEntityList: HhgBolPackagesEntity[];
  bolCorrectionNoticeEntity: BolCorrectionNoticeEntity;
  hhgBillOfLadingInfo: HhgBillOfLadingInfo;
  tspName: string;
  requestedPackDate: string;
  requiredDeliveryDate: string;
  moveDate: string;
  scac: string;
  dunsNumber: string;
  employeeFirstName: string;
  employeeLastName: string;
  employeeMiddleInitial: string;
  shipmentType: string;
  shipmentTypeFromScreen: string[];
  bookShipmentId: number;
  email: string;
  additionalRemarks: string;
}

export class HhgBolPackagesEntity {
  hhgBookPackagesId: number;
  hhgBolDetailsId: number;
  packageLineNo: number;
  totalPieces: number;
  packageType: string;
  packageWeight: number;
  packageDescription: string;
  additionalInfo: string;
  shipmentType: string;
}

export class BolCorrectionNoticeEntity {
  bolCorrectionNoticeId: number;
  billOfLadingNbr: string;
  authorityForCorrection: string;
  correctionRemarks: string;
  hhgBolDetailsEntity: HhgBillOfLadingDetails;
}

export class FrtBillOfLadingDetails {
  frtBolDetailsID: number;
  shipmentsInfoId: number;
  bolNumber: string;
  bolVersion: number;
  bolStatus: string;
  transitTimeExpired: number;
  creationDate: Date;
  frtBolCorrectionNoticeEntity: BolCorrectionNoticeEntity;
  frtShipmentDeliveryDetails: FrtShipmentDeliveryEntity;
  shipmentsInfoEntity: any;
  carrier: Carrier;
  organizationId: number;
  agencyBureauName: string;
  agencyCode: string;
  bureauCode: string;
  additionalRemarks: string;

  // requiredDeliveryDate: Date;
  // moveDate: Date;
  // tspName: string;
  // scac: string;
  // dunsNumber: string;
}

export class FrtShipmentSealNos {
  frtShipmentSealNosId: number;
  frtShipmentDetailsId: number;
  sealNoLine: number;
  sealNumber: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class FrtShipmentPurchaseOrder {
  frtShipmentPurchaseOrderId: number;
  frtShipmentDetailsId: number;
  purchaseOrderNoLine: number;
  purchaseOrderNumber: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class ExtendedStorage {
  hhgExtStorageShipmentId: number;
  carrierId: number;
  scac: string;
  storageStateId: number;
  storageStateAbbrev: string;
  referenceNumber: number;
  shipmentWeight: number;
  packingDate: Date;
  dateIntoExtraStorage: Date;
  storageType: string;
  reportingYear: number;
  reportingQuarter: number;
  amountInvoiced: number;
  faicCode: string;
  employeeLastName: string;
}

export class FrtDieselPrice {
  frtDieselPriceId: number;
  dieselPrice: number;
  currentWeekMondayDate: any;
  currentWeekWednesdayDate: any;
  nextWeekTuesdayDate: any;
  updateProgram: string;
  updateId: number;
  updateDate: any;
}

export class FrtRatesZone {
  frtRatesZoneId: number;
  agencyMasterId: number;
  zoneCode: string;
  zoneName: string;
  zoneCity: string;
  zoneState: string;
  zoneZip: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  bureauName: string;
  agencyName: string;
}

export class FrtShopRatesIn {
  pickupDate: string;
  sroType: string;
  sroId: number;
  carrierId: number;
  originId: number;
  destinationId: number;
  estimatedMileage: number;
  estimatedWeight: number;
  estimatedCuFt: number;
  rateId: number;
  accessorials?: any;
  autoCategory: string;
  numberOfVehicles: number;
}

export class HhgIcc {
  iccId: number;
  iccCode: string;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class HhgCustomerSatisfactionIndex {

  hhgCsiId: number;
  carrierId: number;
  controlId: number;
  domesticCsi: any;
  internationalCsi: any;
  dosInternationalCsi: any;
  dosDomesticCsi: any;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  scac: string;
}

export class FrtAccesorial {
  frtAccessorialId: number;
  unitsId: number;
  quantity: number;
  estimatedCost: number;
}

export class FrtShipmentDeliveryEntity {
  frtShipmentDeliveryId: number;
  frtBolDetailsId: number;
  actualPickupDate: Date;
  actualDeliveryDate: Date;
  additionalComments: string;
  sentToSyncada: number;
  dateSentToSyncada: Date;
  updateProgram: string;
  updateId: number;
  updateDate: Date;

}

export class UserSession {
  jSessionId: string;
  organizationId: number;
  userId: number;
  roleId: number;
}

export class FrtRatesBidcycles {
  ratesBidcyclesId: number;
  bidCycleName: string;
  businessType: string;
  bidWindowOpenDate: Date;
  bidWindowCloseDate: Date;
  rateEffectiveDate: Date;
  rateExpiryDate: Date;
  releaseDateProduction: Date;
  tspParticipationOpenDate: Date;
  tspParticipationCloseDate: Date;
  pcMilerVersion: number;
  fuelSurchargeVersion: string;
  ltlBaselineVersion: string;
  additionalInformation: string;
  userId: number;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
  assignedSroMasterIds: number[];
  assignedAccessorailMasterIds: number[];
  hhgSupplementalFiling?: any;
  publishEmail: any;
}

export class FrtRatesBidcyclesSros {
  ratesBidcyclesSrosId: number;
  ratesBidcyclesId: number;
  sroMasterId: number;
  userId: number;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class FrtAccessorialMandatory {
  frtAccessorialMandatoryId: number;
  frtAccessorialMasterId: number;
  controlId: number;
  updateProgram: string;
  updateId: number;
  updateDate: Date;
}

export class RateTypesSroPojo {
  rateTypeSroId: number;
  sroMasterId: number;
  sroId: string;
  businessType: string;
  sroType: string;
}

export class ReQueryFormData {
  pickupDate: any;
  sroType: string;
  sroId: number;
  originId: any;
  destinationId: any;
  estimatedMileage: number;
  estimatedWeight: number;
  estimatedCuFt: number;
  accessorials?: any;
  asyncOriginSearchString?: any;
  asyncDestinationSearchString?: any;
}

export class HhgQueryRequest {
  rateId: number;
  originId: number;
  destinationId: number;
  originZip: string;
  destZip: string;
  originStateAbbr: string;
  destStateAbbr: string;
  estimatedWeight: number;
  shipmentType: string;
  pickupDate: Date;
}

export class CarrierLocalAgentsEntity {
  agentScac: string;
  agentName: string;
  agentEmail: string;
  agentPhone: string;
  agentStatus: string;
  updateId: number;
  carrierId: number;
}

export class FRTSyncadaIFFStagingEntity {
  frtSyncadaIffStagingId: number;
  docType: string;
  invoiceNumber: string;
  bolNumber: string;
  iffNumber: string;
  fuelSC: number;
  billableIFFAmount: number;
  iffAmount: number;
  iffPercentage: number;
  iffFinStat: string;
  iffStatusDate: string;
  carrierName: string;
  scac: string;
  invoiceDate: string;
  billToName: string;
  buyerID: string;
  mode: string;
  shipperName: string;
  originCity: string;
  originState: string;
  originZipCode: string;
  originCountry: string;
  destCity: string;
  destState: string;
  sentDate: string;
  bookShipmentId: number;
  moveDate: string;
  destCountry: string;
  bolExpectedAmount: number;
  invoicePaidAmount:number;
  totalCost: number;
  destZipCode: string;
  invoicePaidDate: string;
}

export class frtshipmentreview{
  shipmentId: number;
  bolNumber: string;
  carrierName: string;
  movingEmpLastName: string;
  originCity: string;
  originState: string;
  originZip: string;
  originCountry: string;
  origin: string;
  destCity: string;
  destState: string;
  destZip: string;
  destContry: string;
  destination: string;
  moveDate: string;
  bookingStatus: string;
  oneTimeOnly: string;
  actualDeliveryDate: string;
  sentToSyncada: string;
  dateSentToSyncada: string;
  linehaulCost: number;
  fuelSurchargeCost: number;
  totalCost: number;
  estimatedIffDue: number;
  agencyShipmentIdNo: number;
  weight: number;
  miles: number;
  smartWayScore: number;
  carrierId: number;
  ses: string;
  updateDate: string;
  tspOrgId: number;
  tspEmail: string;
  tspFirstName: string;
  tspLastName: string;
  deliveryDate: string;
  agencyBureauName: string;
  mode:string;
}

export const BreadCrumbsObj = {
  'styleguide': 'Style Guide',
  'styleguide-uswds': 'Style Guide USWDS',
  'sandbox': 'Sand Box',
  'home': 'Home',
  'help': 'Help',
  'landing': 'Landing',
  'termsAndConditions': 'Terms & Conditions',
  'validatesso': 'Validate SSO',
  'agencytspsearch': 'User Administration',
  'agencyuser': 'TSP User List',
  'agencyprofile': 'Agency Profile',
  'carrierprofile': 'TSP Profile',
  'customerapprovallist': 'Customer (Agency) Approval',
  'customerapproval': 'Customer Approval',
  'mailinglistreport': 'Mailing List',
  'faiclist': 'FAIC List',
  'frtlist': 'FRT Spending Report - Agencies',
  'frtTspList': 'FRT Spending  - TSPs',
  'hhglist': 'HHG Shipment Summary Report',
  'customerregistration': 'Customer Registration',
  'survey': 'Survey',
  'adminSurvey': 'GSA 3080 Admin',
  'evaluationForm': 'Evaluation Form',
  'hhgscope': 'HHG Scopes',
  'frtratefileopen': 'FRT Rate File Open',
  'hhgratefileopen': 'HHG Rate File Open',
  'ratefiletspext': 'TSP Rate File Extension',
  'hhgratefiletspext': 'HHG TSP Rate File Extension',
  'frtratefiletspext': 'FRT TSP Rate File Extension',
  'workgroupadmin': 'Work Group Admin',
  'workgrouppermissions': 'Work Group Permissions',
  'ratessromaintenance': 'Define HHG SRO',
  'carrierrateproc': 'TSP Rate Proc Report',
  'carrierapproval': 'TSP Approval',
  'hhgratefiling': 'HHG Rate Filing',
  'hhgrateedit': 'HHG Rate Edit',
  'frtrateedit': 'FRT Rate Edit',
  'ratecarryover': 'Rate Carry Over',
  'viewhhgrates': 'View HHG Rates',
  'frtratesdownload': 'FRT Rates Download',
  'viewfrtrates': 'View FRT Rates',
  'hhgglobalupdate': 'HHG Global Update',
  'frtglobalupdate': 'FRT Global Update',
  'duns': 'DUNS',
  'tspParticipation': 'TSP Participation',
  'frtbookshipment': 'FRT Book Shipment',
  'frtonetimebookshipment': 'One Time Shipment',
  'upload': 'Upload',
  'iff-upload': 'Upload HHG/SIT Shipment Reports',
  'download': 'File Downloads',
  'nonusetsp':'Revoked TSPs',
  'downloadcurrentpastrates': 'Download Current/Past Rates',
  'freightquery': 'FRT Queries',
  'freightotoshipmentrequest': 'FRT OTO Shipment Request',
  'signon': 'Sign On',
  'hhgratequery': 'HHG Queries',
  'userprofile': 'User Profile',
  'accountinfo': 'Account Info',
  'iffrates': 'AF Admin',
  'forgotpassword': 'Forgot Password',
  'resetpassword': 'Reset Password',
  'newuser': 'New User',
  '3080-upload': 'GSA 3080 File Upload',
  '3080-download': 'GSA 3080 File Download',
  'hhgbookshipment': 'HHG Book Shipment',
  'bookshipmentaddresses': 'Book Shipment Addresses',
  'hhgshipmentaccessorials': 'HH Shipment Accessorials',
  'shipmentaudit': 'Shipment Audit',
  'frtshipmentreview': 'FRT Shipment',
  'hhgshipmentreview': 'HHG Shipment',
  'shipmentcontrolreview': 'Shipment Control Review',
  'frtshipmentaccessorials': 'FRT Shipment Accessorials',
  'hhgbilloflading': 'HHG Bill of Lading',
  'frtbilloflading': 'FRT Bill of Lading',
  'hhgIffSummary': 'HHG Shipment Reports',
  'frtIffSummary': 'FRT Shipment Reports',
  'sitIffSummary': 'SIT Shipment Reports',
  'hhgIffDetail': 'HHG IFF Detail',
  'frtIffDetail': 'FRT IFF Detail',
  'hhgDelinquency': 'HHG Delinquency Report',
  'sitDelinquency': 'SIT Delinquency Report',
  'frtDelinquency': 'FRT Delinquency Report',
  'frtpackageinfo': 'FRT Package Info',
  'masterdataadmin': 'Master Data Admin',
  'localagents': 'Local Agent',
  'xtosreporting': 'XTOS Shipment Reports',
  'xtosComprehensiveReport': 'XTOS Comprehensive Shipment Reports',
  'xtosDelinquencyReport': 'XTOS Delinquency Shipment Reports',
  'negativeShipmentSubmission': 'Negative Shipment Reporting',
  'hhgratescsvdownload': 'HHG Rates Download',
  'frtratescsvdownload': 'FRT Rates Download',
  'hhgComprehensiveReport': 'HHG Comprehensive Shipment Reports',
  'sitComprehensiveReport': 'SIT Comprehensive Shipment Reports',
  'frtComprehensiveReport': 'FRT Comprehensive Shipment Reports',
  'carrierReports': 'GSA 3080 TSP Report',
  'summaryReports': 'GSA 3080 Comprehensive Report',
  'amcReports': 'GSA 3080 AMC Report',
  'surveyAdminReports': 'GSA 3080 TSP Evaluation Report',
  'hhgRatesScopeReport': 'HHG Scope Report',
  'shipmentDelivery': 'Shipment Delivery',
  'userselection': 'User Selection',
  'documentmanagement': 'Document Management',
  'viewDocumentPackage': 'View Document Package',
  'ratesfrtsromaintenance': 'Define FRT SRO',
  'frtratesbidcyles': 'FRT Rate Filing Admin',
  'hhgratesbidcyles': 'HHG Rate Filing Admin',
  'carriercontact': 'TSP Contact',
  'userpreferences': 'Data View Preferences',
  'agencytokenapi': 'Agency Token API',
  'broadcastmessages': 'Broadcast Messages',
  'notifyusers': 'Notify Users',
  'loginHistoryReport': 'Login History Report',
  'gsa3080initiation': 'GSA 3080 Initiation',
  'hhgView': 'HHG View Rates',
  'hhgAdd': 'HHG Add Rates',
  'hhgEdit': 'HHG Edit Rates',
  'hhgGlobal': 'HHG Global Update',
  'hhgUpload': 'HHG Upload Rate File',
  'hhgTemplate': 'HHG Template Download',
  'frtView': 'FRT View Rates',
  'frtTemplate': 'FRT Template Download',
  'frtUpload': 'FRT Upload Rate File',
  'frtEdit': 'FRT Edit Rates',
  'frtGlobal': 'FRT Global Update',
  'hhgRatesQueryReport': 'HHG Rates Query Report',
  'hhguabcalculator': 'HHG UAB Cost Calculator',
  'tspstatusportal': 'HHG TSPs in Temp Non-Use',
  'tspHhgShpmntRptStatus' : 'HHG Shipment Report Status',
  'tspSitShpmntRptStatus' : 'SIT Shipment Report Status',
  'recertifyuser': 'Recertify Users',
  'tspXtosShpmntRptStatus': 'XTOS Shipment Report Status',
  'tspXtosSingleShpmntRptStatus': 'XTOS Single Shipment Report Status',
  'tspXtosComprehensiveRpt': 'XTOS Comprehensive Shipment Reports',
  'frtOnTimeSummary': 'Frt On-Time Shipment Reports',
  'frtTspRating': 'FRT TSP Performance Metrics',
  'frtshipmentpod': 'FRT Shipment POD Report',
  'frtsyncadashipmentinvoices': 'FRT Syncada Shipment Invoices',
  'frtshipmentcomprehensivereport': 'FRT Comprehensive Shipment Report'
};
